export default {
  data() {
    return {
      users: [
        { text: this.$t('rtrck.grid.title.user.total'), rowKey: 'USER_0' },
        { text: this.$t('rtrck.grid.title.user.active'), rowKey: 'USER_1' },
        { text: this.$t('rtrck.grid.title.user.idle'), rowKey: 'USER_2' },
        { text: this.$t('rtrck.grid.title.user.unchange'), rowKey: 'USER_3' },
        { text: this.$t('rtrck.grid.title.user.less'), rowKey: 'USER_4' },
        { text: this.$t('rtrck.grid.title.user.lock'), rowKey: 'USER_5' },
        { text: this.$t('rtrck.grid.title.user.expire'), rowKey: 'USER_6' },
      ],
      crols: [
        { text: this.$t('rtrck.grid.title.crol.total'), rowKey: 'CROL_0' },
        { text: this.$t('rtrck.grid.title.crol.unassign'), rowKey: 'CROL_1' },
        { text: this.$t('rtrck.grid.title.crol.missing'), rowKey: 'CROL_2' },
        { text: this.$t('rtrck.grid.title.crol.comparison'), rowKey: 'CROL_3' },
      ],
      srols: [
        { text: this.$t('rtrck.grid.title.srol.total'), rowKey: 'SROL_0' },
        { text: this.$t('rtrck.grid.title.srol.unassign'), rowKey: 'SROL_1' },
        { text: this.$t('rtrck.grid.title.srol.missing'), rowKey: 'SROL_2' },
        { text: this.$t('rtrck.grid.title.srol.generation'), rowKey: 'SROL_3' },
        { text: this.$t('rtrck.grid.title.srol.comparison'), rowKey: 'SROL_4' },
      ],
      cprfs: [
        { text: this.$t('rtrck.grid.title.cprf.total'), rowKey: 'CPRF_0' },
        { text: this.$t('rtrck.grid.title.cprf.unassign'), rowKey: 'CPRF_1' },
        { text: this.$t('rtrck.grid.title.cprf.missing'), rowKey: 'CPRF_2' },
      ],
      sprfs: [
        { text: this.$t('rtrck.grid.title.sprf.total'), rowKey: 'SPRF_0' },
        { text: this.$t('rtrck.grid.title.sprf.unassign'), rowKey: 'SPRF_1' },
      ],
    };
  },
};
